import { documentDirectory, StorageAccessFramework, EncodingType } from '../../utils/fileSystemCompat'
import React, { useState, useEffect } from 'react'
import { ScrollView, Text, View, TouchableOpacity, Linking, TextInput, Modal, Alert, StatusBar, Dimensions, PixelRatio } from 'react-native'
import { Feather } from '@expo/vector-icons'
// import { fetchAuthSession } from 'aws-amplify/auth'
import { signOut, getCurrentUser, updateUserAttributes, fetchUserAttributes, sendUserAttributeVerificationCode, updateUserAttribute } from 'aws-amplify/auth'
import { getAuthToken, validateConnectionNetwork } from '../../utils/functions.utils'
import { uploadData, getUrl } from 'aws-amplify/storage'
import { useNavigation } from '@react-navigation/native'
import { ProfileSection } from './ProfileSection'
import { ProfileContact } from './ProfileContact'
import { Image } from 'expo-image'
import ProfileHeader from './ProfileHeader'
import {
    deleteAllTables,
    openDB,
    getGlobalVersion,
    updateGlobalVersion,
    getUser,
    addUser,
    deleteDB,
    deleteAllTablesContent,
    updateUser,
    deleteDatabase,
} from '../../db/indexDB'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import theme from '../../../theme'
import NetInfo from '@react-native-community/netinfo'
import { apiUrl } from '../../config/config'
import { useDeviceStore } from '../../redux/zustand/deviceInfoStore'
import awsconfig from '../../aws-exports'
import { getImageStogeUrl } from '../imageUploader/ImageStorage'
import { avatarPlaceholder, getAvatarPlaceholderLocal } from '../customUtils/Constants'
import { safeImageSource } from '../../utils/imageUtils'
import styles from './ProfileScreenStyles'
import { TrackingServices } from '../../../database/tracking.database'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { BottomSheetAlert } from '../modals/BottomSheetAlert'
import { getDeviceInfo, eventEmitter, deleteZipFolder, downloadAvatarUser, isEntornoTesting } from '../../utils/functions.utils'
import { getAppVersion } from '../customUtils/AppConstants'
import { getConection } from '../appBar/context/HeaderContext'
import { SelectList } from 'react-native-dropdown-select-list'
import { updateAttributesCognito, verifyEmailCode, verifyPhoneNumberCode } from '../../utils/cognitoUtils'
import { request_get_user_profile } from '../../services/user.services'
import { manipulateAsync } from 'expo-image-manipulator'
import { getPlatform, isIOS } from '../../utils/platformUtils'
import EmailWidget from '../customUtils/Components/EmailWidget'
import Constants from 'expo-constants'
import { ProfileDividerTheme, routeStores } from '../../../themeConstants'
import { useNavigateTabsStore } from '../../redux/zustand/navigateTabsStore'
import { useLoaderSaveStores } from '../../redux/zustand/loaderSaveStore'
import { StorageAdapter } from '../../utils/AsyncStorage'
import { ASYNC_STORAGE_KEYS } from '../stores/constants/constants.storage'
import { LinearGradient } from 'expo-linear-gradient'
import * as Sharing from 'expo-sharing'
import * as FileSystem from 'expo-file-system'
import { Platform } from 'react-native'
import { LoginBiometricsStorage } from '../../utils/LoginBiometricsStorage'
import { useProgressSchedule } from '../../redux/zustand/progressScheduleStore'
import { useFormIncidenceStore } from '../../redux/zustand/formIncedenceStore'
import { useTermsAndConditionsStore } from '../../redux/zustand/termsAndContionsStore'
import { useCacheClearedStore } from '../../redux/zustand/useCacheClearedStore'
import { useDataPendingSendStore } from '../../redux/zustand/dataPendingSendStore'
import { useLearningStore } from '../../redux/zustand/useLearningCourse'
import { resetCache } from '../../utils/FetchServices'
import { TRACKINGS_TYPES } from '../../utils/Constants'
import { UserServices } from '../../../database/user.database.js'
import { RecoverPasswordView } from '../auth/RecoverPasswordView'

const expoConfig = Constants.expoConfig || { slug: '' }

export const isEnabledEditParams = () => {
    const slug = expoConfig.slug
    return slug === 'shell-somosprotagonistas' || slug === 'dots' || slug === 'dots-ii'
}

export const ProfileScreen = () => {
    const { deviceId, token_notification } = useDeviceStore()
    const navigation = useNavigation()
    const [reload, setReload] = useState(false)
    const [user_data, setUser] = useState(null)
    const { openBottomSheet, closeBottomSheet } = useBottomSheet()
    const [avatarUrl, setAvatarUrl] = useState(null)
    const [activeButtonDeleted, setActiveButtonDeleted] = useState(false)
    const [loading, setLoading] = useState(false)
    const { isConnected, hasInternet } = getConection()
    const { languageFile } = getLanguage()
    const [formData, setFormData] = useState({})
    const [languages, setLanguages] = useState([])
    const [newLanguage, setNewLanguage] = useState('')
    const [defaultLanguage, setDefaultLanguage] = useState('')
    const [showLanguageAlert, setShowLanguageAlert] = useState(false)
    const [photoURL, setPhotoURL] = useState('')
    const [verifiedEmail, setVerifiedEmail] = useState(false)
    const [verifiedPhone, setVerifiedPhone] = useState(false)
    const [cognitoHasEmail, setCognitoHasEmail] = useState(false)
    const [cognitoHasPhone, setCognitoHasPhone] = useState(false)
    const PREFIX = '+549'

    const [showRecoverPassword, setShowRecoverPassword] = useState(false)
    const [currentUsername, setCurrentUsername] = useState('')

    const [isButtonDisabled, setIsButtonDisabled] = useState(false)
    const [timer, setTimer] = useState(0)
    const setIndexTab = useNavigateTabsStore((state) => state.setIndexTab)
    const resetValues = useLoaderSaveStores((state) => state.resetValues)
    const resetProgressSchedule = useProgressSchedule((state) => state.resetProgressSchedule)
    const clearDataFormIncidence = useFormIncidenceStore((state) => state.clearDataFormIncidence)
    const resetTermsAndConditions = useTermsAndConditionsStore((state) => state.resetTermsAndConditions)
    const setCacheCleared = useCacheClearedStore((state) => state.setCacheCleared)
    const setHavePendingData = useDataPendingSendStore((state) => state.setHavePendingData)
    const clearCourse_store = useLearningStore(state => state.clearCourse)

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const hasConnection = validateConnectionNetwork()
                if (hasConnection) {
                    const userAttributes = await fetchUserAttributes()
                    
                    const hasEmail = userAttributes.hasOwnProperty('email') && !!(userAttributes.email && userAttributes.email.trim() !== '')
                    const hasPhone = userAttributes.hasOwnProperty('phone_number') && !!(userAttributes.phone_number && userAttributes.phone_number.trim() !== '')
                    
                    setCognitoHasEmail(hasEmail)
                    setCognitoHasPhone(hasPhone)
                    
                    if (hasEmail) {
                        setVerifiedEmail(userAttributes?.email_verified || false)
                    }
                    if (hasPhone) {
                        setVerifiedPhone(userAttributes?.phone_number_verified || false)
                    }

                } else {

                    const user = await getUser()

                    if (!user) return

                    const hasEmail = user.hasOwnProperty('email') && !!(user.email && user.email.trim() !== '')
                    const hasPhone = user.hasOwnProperty('phone') && !!(user.phone && user.phone.trim() !== '')
                    
                    setCognitoHasEmail(hasEmail)
                    setCognitoHasPhone(hasPhone)
                    
                    if (hasEmail) {
                        setVerifiedEmail(user?.email_verified || false)
                    }
                    if (hasPhone) {
                        setVerifiedPhone(user?.phone_verified || false)
                    }

                }
            } catch (error) {
                console.error('Error al obtener el usuario autenticado:', error)
            }
        }
        
        fetchUser()
    }, [])

    const ExportDatabase = async () => {
        try {
            if (Platform.OS === 'web') {
                Alert.alert('No disponible', 'La exportación de base de datos no está disponible en web.')
                return
            }
            // Ruta del archivo original de la base de datos
            const dbPath = documentDirectory + 'SQLite/myDB'

            // Verifica si el archivo de base de datos existe
            const fileInfo = await FileSystem.getInfoAsync(dbPath)
            if (!fileInfo.exists) {
                throw new Error('El archivo myDB.db no existe en el directorio especificado')
            }

            // Si la plataforma es Android, solicitamos permiso para escribir en el almacenamiento externo
            if (!isIOS()) {
                const permissions = await StorageAccessFramework.requestDirectoryPermissionsAsync()
                if (permissions.granted) {
                    // Leer el archivo como base64
                    const base64 = await FileSystem.readAsStringAsync(dbPath, {
                        encoding: 'base64',
                    })

                    // Crear un archivo en el directorio seleccionado
                    const newFileUri = await StorageAccessFramework.createFileAsync(
                        permissions.directoryUri,
                        'myDB.db',
                        'application/octet-stream', // Tipo de archivo (binary/octet-stream)
                    )

                    // Escribir el contenido del archivo como base64 en la nueva ubicación
                    await FileSystem.writeAsStringAsync(newFileUri, base64, {
                        encoding: 'base64',
                    })

                    console.log('Base de datos exportada exitosamente a:', newFileUri)
                } else {
                    console.error('Permisos denegados para acceder al directorio.')
                }
            } else {
                // En iOS, compartir directamente desde la ubicación original
                await Sharing.shareAsync(dbPath)
            }
        } catch (error) {
            console.error('🚀 ~ ExportDatabase ~ error:', error)
        }
    }

    

    useEffect(() => {
        let interval
        if (timer > 0) {
            interval = setInterval(() => {
                setTimer((prevTimer) => prevTimer - 1)
            }, 1000)
        } else if (timer === 0 && isButtonDisabled) {
            setIsButtonDisabled(false)
        }
        return () => clearInterval(interval)
    }, [timer])

    const handleVerificationClick = (type) => {
        handleResendCode(type)
        setIsButtonDisabled(true)
        setTimer(120) // 2 minutos = 120 segundos
    }

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60)
        const remainingSeconds = seconds % 60
        return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`
    }

    const width = Dimensions.get('window').width

    const handleFormChange = (key, value) => {
        setFormData({
            ...formData,
            [key]: value,
        })
    }
    

    const fieldsMap = {
        Email: 'email',
        Teléfono: 'phone',
        Nombre: 'name',
        Apellido: 'last_name',
        Rol: 'role',
        ...(isEnabledEditParams() && { Area: 'area' }),
    }

    const onSave = (new_data) => {
        if (new_data) {
            setUser({ ...user_data, languages: new_data['languages'], delete_active: new_data['languages'] })
        }
        openBottomSheet(null) // Cierra el modal al guardar los cambios
    }

    const fetchData = async () => {
        try {
            let data
            const database = await openDB()
            const currentGlobalVersion = await getGlobalVersion(database, 'user')
            const netInfoState = await NetInfo.fetch()
            let user = await getUser(database)
            console.log('🚀 ~ fetchData ~ user from DB:', user)
            if (user) {
                setUser(user)
            }
            if (netInfoState.isConnected && netInfoState.isInternetReachable) {
                const authToken = await getAuthToken()
                if (!authToken) return
                // authToken ya obtenido por getAuthToken
                const device_param = {
                    device_key: deviceId,
                    token_notification: token_notification,
                }
                const headersParam = {
                    version: currentGlobalVersion,
                    device_key: deviceId,
                    device: JSON.stringify(device_param),
                    app_version: getAppVersion(), //expo.expo.android.versionCode.toString(),
                    system: getPlatform().OS,
                    deviceInfo: JSON.stringify(getDeviceInfo()),
                }
                data = await request_get_user_profile({ authToken, headersParam })

                console.log('🚀 ~ fetchData ~ data from API:', data)

                if (data) {
                    if (data?.single?.delete_active) {
                        setActiveButtonDeleted(data.single.delete_active)
                    }
                } else {
                    data = {
                        status: 0, // Asume un status 0 que es cuando tiene la misma version que la api // si paso status 2 tomo la data harcodeada
                    }
                }
            } else {
                data = {
                    status: 0, // Asume un status 0 que es cuando tiene la misma version que la api // si paso status 2 tomo la data harcodeada
                }
            }

            console.log('[ProfileScreen] fetchData status:', data?.status, 'platform:', Platform.OS)
            if (data?.status === 1) {
                // Amplify v6: tokens están en session.tokens
                const userAttributes = await fetchUserAttributes()
                console.log('🚀 ~ fetchData ~ userAttributes:', userAttributes)
                // const sub = session?.tokens?.idToken?.payload?.sub || null
                const sub = userAttributes?.sub || null
                const user_data = {
                    ...data.single.user_data,
                    delete_active: data.single.delete_active,
                    languages: data.single.languages,
                    login: true,
                    cognito_id: sub,
                    showClearCacheButton: data.single.showClearCacheButton ?? false,
                }
                setVerifiedEmail(user_data?.email_verified || false)
                setVerifiedPhone(user_data?.phone_verified || false)
                setUser(user_data)

                const initialFormData = {}
                try {
                    console.log('[ProfileScreen] user_data keys (online):', Object.keys(user_data || {}))
                } catch {}
                for (const key in fieldsMap) {
                    if (user_data && Object.prototype.hasOwnProperty.call(user_data, fieldsMap[key])) {
                        initialFormData[key] = user_data[fieldsMap[key]]
                    }
                }
                try {
                    console.log('[ProfileScreen] initialFormData keys (online):', Object.keys(initialFormData))
                } catch {}
                if (user_data.languages && user_data.languages.length > 0) {
                    setLanguages(user_data.languages)
                }
                const defaultLanguage = user_data.lenguage ?? ''
                setDefaultLanguage(defaultLanguage)
                const photo_url = user_data.avatar_image ?? ''
                setPhotoURL(photo_url)
                setFormData(initialFormData)

                // Guardar usuario
                try {
                    await addUser(database, user_data)
                } catch {}
                let version_update = data.single.user_data.data_version ? data.single.user_data.data_version : 0
                await updateGlobalVersion(database, 'user', version_update)
                return data.single.user_data
            } else {
                try {
                    // Rama offline o sin actualización
                    setVerifiedEmail(user?.email_verified || false)
                    setVerifiedPhone(user?.phone_verified || false)
                    const initialFormData = {}
                    try {
                        console.log('[ProfileScreen] user keys (offline):', Object.keys(user || {}))
                    } catch {}
                    // Fallback: si no hay usuario local pero hay conectividad, forzar fetch completo (version=0)
                    if ((!user || Object.keys(user).length === 0) && netInfoState.isConnected && netInfoState.isInternetReachable) {
                        try {
                            console.log('[ProfileScreen] No local user found; forcing full profile fetch...')
                            // Recontruir session y headers acá (no existen en este scope)
                            const authToken = await getAuthToken()
                            if (!authToken) return
                            const device_param2 = {
                                device_key: deviceId,
                                token_notification: token_notification,
                            }
                            const headersParam2 = {
                                version: '0',
                                device_key: deviceId,
                                device: JSON.stringify(device_param2),
                                app_version: getAppVersion(),
                                system: getPlatform().OS,
                                deviceInfo: JSON.stringify(getDeviceInfo()),
                            }
                            const forced = await request_get_user_profile({
                                authToken: authToken,
                                headersParam: headersParam2,
                                retries: 1,
                                timeout: 5,
                            })
                            if (forced?.status === 1) {
                                const forcedUser = {
                                    ...forced.single.user_data,
                                    delete_active: forced.single.delete_active,
                                    languages: forced.single.languages,
                                    login: true,
                                    cognito_id: null,
                                    showClearCacheButton: forced.single.showClearCacheButton ?? false,
                                }
                                setUser(forcedUser)
                                setVerifiedEmail(forcedUser?.email_verified || false)
                                setVerifiedPhone(forcedUser?.phone_verified || false)
                                for (const key in fieldsMap) {
                                    if (forcedUser && Object.prototype.hasOwnProperty.call(forcedUser, fieldsMap[key])) {
                                        initialFormData[key] = forcedUser[fieldsMap[key]]
                                    }
                                }
                                if (forcedUser.languages && forcedUser.languages.length > 0) {
                                    setLanguages(forcedUser.languages)
                                }
                                const defaultLanguage2 = forcedUser.lenguage ?? ''
                                setNewLanguage(defaultLanguage2)
                                setDefaultLanguage(defaultLanguage2)
                                const photo_url2 = forcedUser.avatar_image ?? ''
                                setPhotoURL(photo_url2)
                                setFormData(initialFormData)
                                try {
                                    await addUser(database, forcedUser)
                                } catch {}
                                let version_update2 = forced.single.user_data.data_version ? forced.single.user_data.data_version : 0
                                await updateGlobalVersion(database, 'user', version_update2)
                                console.log('[ProfileScreen] Forced fetch succeeded; populated formData keys:', Object.keys(initialFormData))
                                return forced.single.user_data
                            }
                        } catch (e) {
                            console.log('[ProfileScreen] Forced fetch failed:', e?.message || e)
                        }
                    }
                    if (user) {
                        for (const key in fieldsMap) {
                            if (user && Object.prototype.hasOwnProperty.call(user, fieldsMap[key])) {
                                initialFormData[key] = user[fieldsMap[key]]
                            }
                        }
                    }
                    try {
                        console.log('[ProfileScreen] initialFormData keys (offline):', Object.keys(initialFormData))
                    } catch {}
                    if (user?.languages && user.languages.length > 0) {
                        setLanguages(user.languages)
                    }
                    const defaultLanguage = user?.lenguage ?? ''
                    setNewLanguage(defaultLanguage)
                    setDefaultLanguage(defaultLanguage)
                    const photo_url = user?.avatar ?? ''
                    setPhotoURL(photo_url)
                    setFormData(initialFormData)
                    return user
                } catch (error) {
                    console.log('🚀 ~ user= ~ error:', error)
                }
            }
        } catch (error) {
            console.error('Error al obtener el usuario autenticado:fetch data profile', error)
        }
    }

    useEffect(() => {
        try {
            fetchData()
                .then((user) => {
                    if (user && user['_id']) {
                        TrackingServices.addTracking(user['_id'], 'get_user_profile', 'users').catch((error) => console.error(error))
                    }
                })
                .catch((error) => console.error(error))
        } catch (error) {
            console.error(error)
        }
    }, [reload])

    const onLanguageChange = async (val) => {
        setNewLanguage(val)
        changeLanguage(val)
    }

    const goEditProfile = () => {
        setReload(true)
        const params_user = {
            item: user_data,
            avatar: avatarUrl,
        }
        navigation.navigate('EditProfile', params_user) // TODO: setear aca el nombre de la view que se quiere mostrar
    }
    const snapPoints = ['60%']

    const openContact = () => {
        openBottomSheet(<ProfileContact closeBottomShet={(dat) => closeBottomSheet(dat)} />)
    }
    const statesRemoves = async () => {
        try {
            resetProgressSchedule()
            clearDataFormIncidence()
            resetTermsAndConditions()
            clearCourse_store()
            await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.CONTINUE_DOWNLOAD, 'false')
            setIndexTab(-1)
            resetValues()
            setHavePendingData(false)

            Image.clearMemoryCache()
            Image.clearDiskCache()

            resetCache()
        } catch (error) {
            console.error('Error clearing states during logout:', error)
        }
    }

    async function logOut() {
        // const controller = new AbortController();

        setLoading(true)
        try {
            let view_modal = false
            let data
            if (isConnected && hasInternet) {
                const db = await openDB(true)
                const authToken3 = await getAuthToken()
                if (!authToken3) {
                    throw new Error('No auth token available for logout request')
                }
                if (authToken3) {
                    // authToken3 ya obtenido por getAuthToken
                    const response = await fetch(`${apiUrl}/oneapp/logout`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: authToken3,
                            device_key: deviceId,
                        },
                    })
                    data = await response.json()
                    if (!response.ok) {
                        view_modal = true
                    }
                }
                if (data['status'] == 1 || data['status'] == -1 || !authToken3) {
                    // 1. Verificar pendientes y limpiar la base de datos PRIMERO
                    console.log('🧹 Verificando pendientes antes de limpiar base de datos...')
                    try {
                        let pendings = await UserServices.get_pendings_conections()

                        if (pendings && pendings.status == 0) {
                            // Hay datos pendientes de enviar, borrar solo tablas específicas
                            console.log('📦 Hay datos pendientes, limpiando solo tablas específicas...')
                            await UserServices.deleteAllTablesContents()
                            console.log('✅ Tablas específicas limpiadas (pendientes preservados)')
                        } else {
                            // No hay pendientes, borrar todo
                            console.log('🗑️ No hay pendientes, limpiando toda la base de datos...')
                            await deleteDatabase()
                            console.log('✅ Base de datos limpiada completamente')
                        }
                    } catch (error) {
                        console.error('Error verificando pendientes, limpiando toda la DB:', error)
                        await deleteDatabase()
                    }

                    // 2. Limpiar estados y cache
                    setCacheCleared()
                    await statesRemoves()

                    // 3. Finalmente ejecutar el logout (esto emitirá el evento)
                    const { logoutAndReset } = require('../../utils/logout')
                    await logoutAndReset()
                    console.log('------------> Signed out <---------------')
                    // No forzar navegación aquí: Main.jsx redirige al Login
                } else {
                    view_modal = true
                }
            } else {
                view_modal = true
            }
            if (view_modal) {
                let title = languageFile.logout_not_available
                let desc = languageFile.cant_logout
                offlineModal(title, desc)
                // let title = languageFile.logout_not_available
                // let desc = languageFile.cant_logout
                // let button = languageFisle.accept

                // return openBottomSheet(
                //     <BottomSheetAlert
                //         image={require('../../../assets/logoutNotAvailable.png')}
                //         title={title}
                //         desc={desc}
                //         button={button}
                //         closeBottomSheet={closeBottomSheet}
                //     />,
                // )
            }
        } catch (error) {
            console.error('Error signing out: ', error)

            // Limpiar DB antes del logout también en caso de error
            try {
                console.log('🧹 Verificando pendientes antes de limpiar (error en logout)...')
                let pendings = await UserServices.get_pendings_conections()

                if (pendings && pendings.status == 0) {
                    // Hay datos pendientes de enviar, borrar solo tablas específicas
                    console.log('📦 Hay datos pendientes, limpiando solo tablas específicas...')
                    await UserServices.deleteAllTablesContents()
                    console.log('✅ Tablas específicas limpiadas (pendientes preservados)')
                } else {
                    // No hay pendientes, borrar todo
                    console.log('🗑️ No hay pendientes, limpiando toda la base de datos...')
                    await deleteDatabase()
                    console.log('✅ Base de datos limpiada completamente')
                }
            } catch (dbError) {
                console.error('Error limpiando DB:', dbError)
                // En caso de error, intentar borrar todo
                try {
                    await deleteDatabase()
                } catch {}
            }

            const { logoutAndReset } = require('../../utils/logout')
            await logoutAndReset()
            setCacheCleared()
            await statesRemoves()
        } finally {
            setLoading(false)
        }
    }

    // Borrar cache
    const handleDeleteTables = async () => {
        if (isConnected && hasInternet) {
            eventEmitter.emit('starGeneralLoader')
            setLoading(true)
            try {
                await TrackingServices.addTracking(user_data?._id || '', TRACKINGS_TYPES.CLEAR_CACHE, 'ProfileScreen')
                await deleteZipFolder()
                await statesRemoves()

                await deleteAllTables()

                await StorageAdapter.removeItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_SCHEDULE_POS)
                await StorageAdapter.removeItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_STORES)
                await StorageAdapter.removeItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_PERFECT_STORES)
                await StorageAdapter.removeItem(ASYNC_STORAGE_KEYS.STOP_PROCESS_SCHEDULE)
                await StorageAdapter.removeItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_ASSETS_PERFECT_STORES)
                await StorageAdapter.removeItem(ASYNC_STORAGE_KEYS.UNZIP_IN_PROGRESS_PS)
                await StorageAdapter.removeItem(ASYNC_STORAGE_KEYS.SAVE_PS_FORMS)
                await StorageAdapter.removeItem(ASYNC_STORAGE_KEYS.PS_ZIP_ALL_SAVED)
                await StorageAdapter.removeItem(ASYNC_STORAGE_KEYS.PS_ASSETS_ALL_SAVED)

                await openDB(true)
                resetCache() // borrar cache de endpoints
                setCacheCleared()
            } catch (error) {
            } finally {
                let title = languageFile.cache_cleared
                let desc = languageFile.deletes_the_content
                let button = languageFile.accept

                openBottomSheet(
                    <BottomSheetAlert
                        image={require('../../../assets/cacheCleared.png')}
                        title={title}
                        desc={desc}
                        button={button}
                        closeBottomSheet={(dat) => closeBottomSheet(dat)}
                    />,
                )
                setLoading(false)
            }
            eventEmitter.emit('endGeneralLoader')
        } else {
            let title = 'No se puede borrar cache'
            let desc =
                'No puedes borrar cache en este momento porque no tienes conexión a internet. Por favor, verifica tu conexión y vuelve a intentarlo.'
            offlineModal(title, desc)
        }
    }
    const offlineModal = (title, desc) => {
        let button = languageFile.accept

        return openBottomSheet(
            <BottomSheetAlert
                image={require('../../../assets/logoutNotAvailable.png')}
                title={title}
                desc={desc}
                button={button}
                closeBottomSheet={closeBottomSheet}
            />,
        )
    }
    const handleDeleteUser = async () => {
        try {
            let db = await openDB(true)

            const authToken = await getAuthToken()
            if (!authToken) return
            const response = await fetch(`${apiUrl}/oneapp/delete_account`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: authToken,
                    device_key: deviceId,
                },
            })

            console.log('130 🚀 ~ logOut ~ response:', response)
            alert('Tu cuenta fue eliminada correctamente')
            await deleteDB(db)

            try {
                const { logoutAndReset } = require('../../utils/logout')
                await logoutAndReset()
            } catch (e) {
                try {
                    await signOut()
                } catch {}
            }
            onClickDelete && onClickDelete()
            console.log('delete_account')
        } catch (error) {
            console.log('Error delete_account : ', error)
        }
        console.log('usuario eliminadoo')
    }

    const openModal = (key) => {
        console.log('🚀🚀🚀🚀 ~ openModal ~ key:', key)
        openBottomSheet(<ModalContent fieldKey={key} />)
    }

    const ModalContent = ({ fieldKey }) => {
        const [tempValue, setTempValue] = useState(formData[fieldKey]) //formData[fieldKey]
        // Función para guardar el valor editado en el estado global (formData)
        const saveChanges = async () => {
            console.log('saveChanges => ')
            let dataEditada = ''
            if (fieldKey == 'Teléfono') {
                dataEditada = tempValue.startsWith('+549') ? tempValue : PREFIX + tempValue
            } else if (fieldKey == 'Email') {
                dataEditada = tempValue.toLowerCase().trim()
            } else {
                dataEditada = tempValue.trim()
            }

            handleFormChange(fieldKey, dataEditada) // Guardar el valor en formData

            const updatedFormData = {
                ...formData,
                [fieldKey]: dataEditada,
            }

            if (fieldKey == 'Email') {
                setVerifiedEmail(false)
            }

            if (fieldKey == 'Teléfono') {
                setVerifiedPhone(false)
            }

            // Llama a updateProfile con el nuevo estado ya actualizado
            await updateProfile(updatedFormData)
        }

        // {"Apellido": "test", "Email": "tomas@oravian.com", "Nombre": "test", "Rol": "Admin", "Teléfono": "+5491150574793"}

        const renderText = () => {
            const mapText = {
                ['Email']: {
                    title: languageFile.editing_your_email,
                    description: languageFile.modifying_your_email,
                },
                ['Teléfono']: {
                    title: languageFile.editing_your_phone,
                    description: languageFile.modifying_your_phone,
                },
                ['Apellido']: {
                    title: 'Estás editando tu apellido',
                    description: 'Modificando tu apellido',
                },
                ['Nombre']: {
                    title: 'Estás editando tu nombre',
                    description: 'Modificando tu nombre',
                },
            }

            return mapText[fieldKey] || { title: '', description: '' }
        }

        return (
            <View style={styles.containerModal}>
                {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}
                {fieldKey === 'Email' && <Image style={styles.image} source={require('../../../assets/editEmail.png')} />}
                {fieldKey === 'Teléfono' && <Image style={styles.image} source={require('../../../assets/editPhone.png')} />}
                <Text style={styles.title}>{renderText().title}</Text>
                {/* <Text style={styles.description}>{fieldKey === 'Email' ? languageFile.modifying_your_email : languageFile.modifying_your_phone}</Text> */}
                <Text style={styles.description}>{renderText().description}</Text>
                <View style={styles.marginBottom}></View>
                <View style={{ flexDirection: 'row', alignSelf: 'center', alignItems: 'center' }}>
                    {fieldKey === 'Teléfono' && <Text style={{ marginLeft: 12 }}>{PREFIX}</Text>}
                    <TextInput
                        style={[styles.input, styles.marginHorizontal, { textAlign: 'center', marginTop: 0, marginBottom: 0 }]}
                        onChangeText={(value) => {
                            if (fieldKey === 'Teléfono') {
                                // Maneja solo los números sin el prefijo en el input
                                let rawValue = value.startsWith('+549') ? value.slice(4) : value

                                // Limita a 10 caracteres
                                if (rawValue.length <= 10) {
                                    setTempValue(rawValue)
                                }
                            } else {
                                setTempValue(value)
                            }
                        }}
                        value={tempValue && tempValue.startsWith && tempValue.startsWith('+549') ? tempValue.slice(4) : tempValue}
                        placeholder={fieldKey.charAt(0).toUpperCase() + fieldKey.slice(1)}
                        placeholderTextColor={theme.colors.textSecondary}
                        keyboardType={fieldKey === 'Email' ? 'email-address' : 'default'}
                        autoCapitalize={fieldKey === 'Email' ? 'none' : 'words'}
                        editable={true}
                    />
                </View>
                <View style={[styles.buttonContainer, styles.paddingHorizontal, styles.marginBottom]}>
                    <TouchableOpacity onPress={() => saveChanges()} style={styles.mainButton}>
                        <Text style={styles.mainButtonText}>{languageFile.confirm}</Text>
                    </TouchableOpacity>
                    <TouchableOpacity onPress={() => closeBottomSheet(true)} style={styles.borderRedButton}>
                        <Text style={styles.borderRedButtonText}>{languageFile.cancel}</Text>
                    </TouchableOpacity>
                    <View style={styles.spacer1}></View>
                </View>
            </View>
        )
    }

    const searchUpdates = () => {
        if (Platform.OS === 'web') {
            // En web no abrimos tiendas móviles ni mostramos el flujo de actualización
            return
        }
        const appStoreUrl = routeStores.appStoreUrl
        const playStoreUrl = routeStores.playStoreUrl

        const storeUrl = isIOS() ? appStoreUrl : playStoreUrl

        Linking.openURL(storeUrl)
    }

    const changePassword = () => {}

    const handleRecoverPassword = async () => {
        let title = '¿Querés cambiar tu contraseña?'
        let desc = 'Al continuar, se reiniciará tu contraseña actual y te envíaremos un código de verificación para crear una nueva'
        const buttonGoTo = languageFile.accept
        const button = languageFile.cancel
        const goTo = async () => {
            try {
                const user = await getCurrentUser()
                setCurrentUsername(user.username)
                setShowRecoverPassword(true)
                closeBottomSheet(true)
            } catch (error) {
                console.error('Error getting current user:', error)
            }
        }
        openBottomSheet(
            <>
                <View style={{ height: 15 }} />
                <BottomSheetAlert
                    image={require('../../../assets/recover_pass.png')}
                    title={title}
                    desc={desc}
                    buttonGoto={buttonGoTo}
                    button={button}
                    goto={goTo}
                    closeBottomSheet={() => {
                        closeBottomSheet(true)
                    }}
                />
            </>,
        )
        return
        // Alert.alert(languageFile.confirm, '¿Estás seguro que deseas recuperar tu contraseña?', [
        //     {
        //         text: languageFile.cancel,
        //         style: 'cancel',
        //     },
        //     {
        //         text: languageFile.confirm,
        //         onPress: async () => {
        //             try {
        //                 const user = await getCurrentUser()
        //                 setCurrentUsername(user.username)
        //                 setShowRecoverPassword(true)
        //             } catch (error) {
        //                 console.error('Error getting current user:', error)
        //             }
        //         },
        //     },
        // ])
    }

    useEffect(() => {
        const fetchImage = async () => {
            // Priorizar avatar_image sobre avatar
            const avatarKey = user_data?.avatar_image || user_data?.avatar
            if (avatarKey) {
                const url = await getImageStogeUrl(avatarKey)
                if (url) {
                    setAvatarUrl(url)
                    downloadAvatarUser(url, avatarKey).then((uri) => {
                        LoginBiometricsStorage.updateDataBiometricsUser(user_data.user_name, { avatar: uri })
                    })
                }
            }
        }

        fetchImage()
        if (user_data?.showClearCacheButton != null) {
            setShowClearCacheButton(user_data.showClearCacheButton)
        }
    }, [user_data])
    const [showClearCacheButton, setShowClearCacheButton] = useState(false)

    const updateProfile = async (formData) => {
        console.log('updateProfile => formData:', formData)
        closeBottomSheet(true) // Cerrar el BottomSheet

        // Esperar 1 segundo antes de continuar
        await new Promise((resolve) => setTimeout(resolve, 5000))
        try {
            let data
            const authToken5 = await getAuthToken()
            if (!authToken5) return
            // authToken5 ya obtenido por getAuthToken
            const user = await getCurrentUser()
            let originalEmail = user_data['email'].toString().trim()
            let originalPhone = user_data['phone'].toString().trim()
            let editedData = {}
            for (const key in formData) {
                if (formData.hasOwnProperty(key) && formData[key] !== user_data[key]) {
                    editedData[key] = formData[key]
                }
            }

            // console.log('🚀 ~ ~ editedData:', editedData)

            const netInfoState = await NetInfo.fetch()
            if (netInfoState.isConnected) {
                // if (selectedImage) {
                //     editedData = {
                //         ...editedData,
                //         avatar_image: selectedImage.avatar,
                //         avatar_image_thumbnail: selectedImage.thumbnail,
                //     }
                // }
                if (newLanguage != '' && formData.language !== defaultLanguage) {
                    editedData = {
                        ...editedData,
                        language: formData.language,
                    }
                }

                if (
                    (formData['Email'] && formData['Email'].toString().trim() !== originalEmail) ||
                    (formData['Teléfono'] && formData['Teléfono'].toString().trim() !== originalPhone)
                ) {
                    let updateCognito = false

                    // Si el email cambió
                    if (formData['Email'].toString().trim() !== originalEmail) {
                        // Actualizo email en Cognito sin modificar el teléfono aún
                        let emailData = { email: formData['Email'].toString().trim() }

                        console.log('🚀 ~ updateProfile ~ emailData:', emailData)
                        const updateRes = await updateUserAttribute({
                            userAttribute: {
                                attributeKey: 'email',
                                value: formData['Email'].toString().trim(),
                            },
                        })

                        console.log('📲 updateUserAttribute email:', updateRes)

                        // const responseUpdateAttributes = await updateAttributesCognito(emailData, user)
                        // updateCognito = responseUpdateAttributes.success
                        editedData = {
                            ...editedData,
                            email_pending: editedData['Email'],
                        }

                        if (updateRes && updateRes.nextStep.updateAttributeStep === 'CONFIRM_ATTRIBUTE_WITH_CODE') {
                            openBottomSheet(
                                <EmailWidget
                                    type={'email'}
                                    formData={formData}
                                    user_data={user_data}
                                    closeBottomSheet={(dat) => closeBottomSheet(dat)}
                                    fieldsMap={fieldsMap}
                                    fetchData={fetchData}
                                />,
                            )
                        }
                    }

                    // Si el teléfono cambió
                    if (formData['Teléfono'].toString().trim() !== originalPhone) {
                        // Preparo el número de teléfono
                        let phone_number = formData['Teléfono'].toString().trim()
                        // Actualizo el teléfono y no el email
                        console.log('entra', formData)
                        console.log('🚀 ~ updateProfile ~ phone_number:', phone_number)
                        let phoneData = { phone_number }

                        const updateRes = await updateUserAttribute({
                            userAttribute: {
                                attributeKey: 'phone_number',
                                value: phone_number,
                            },
                        })
                        console.log('📲 updateUserAttribute phone_number:', updateRes)

                        // Actualizo teléfono en Cognito
                        // const responseUpdateAttributes = await updateAttributesCognito(phoneData, user)
                        // console.log('responseUpdateAttributes', responseUpdateAttributes)
                        // updateCognito = responseUpdateAttributes.success

                        // console.log('🚀🚀🚀🚀🚀🚀🚀 ~ updateProfile ~ updateCognito:', updateCognito)
                        editedData = {
                            ...editedData,
                            phone_pending: phone_number, //!phone_number.startsWith('+549') ? `+549${editedData['Teléfono']}` : editedData['Teléfono']
                        }

                        if (updateRes && updateRes.nextStep.updateAttributeStep === 'CONFIRM_ATTRIBUTE_WITH_CODE') {
                            openBottomSheet(
                                <EmailWidget
                                    type={'phone'}
                                    formData={formData}
                                    user_data={user_data}
                                    closeBottomSheet={(dat) => closeBottomSheet(dat)}
                                    fieldsMap={fieldsMap}
                                    fetchData={fetchData}
                                />,
                            )
                        }
                    }
                }

                if (formData['Nombre'] && formData['Nombre'].toString().trim() !== user_data['name']) {

                    editedData = {
                        ...editedData,
                        name: formData['Nombre'].toString().trim(),
                    }

                    const updateRes = await updateUserAttribute({
                        userAttribute: {
                            attributeKey: 'name',
                            value: formData['Nombre'].toString().trim(),
                        },
                    })

                    console.log('📲 updateUserAttribute name:', updateRes)

                }
                if (formData['Apellido'] && formData['Apellido'].toString().trim() !== user_data['last_name']) {

                    editedData = {
                        ...editedData,
                        last_name: formData['Apellido'].toString().trim(),
                    }

                    const updateRes = await updateUserAttribute({
                        userAttribute: {
                            attributeKey: 'family_name',
                            value: formData['Apellido'].toString().trim(),
                        },
                    })

                    console.log('📲 updateUserAttribute family_name:', updateRes)

                }

                const response = await fetch(`${apiUrl}/edit_user_profile`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: authToken5,
                    },
                    body: JSON.stringify({
                        user_data: editedData,
                    }),
                })

                if (!response.ok) {
                    throw new Error('Fallo al obtener el usuario')
                }

                data = await response.json()
            } else {
                console.log('sin conexion')
                data = {
                    status: 0,
                }
            }

            if (data?.status === 1) {
                const database = await openDB()
                try {
                    //await deleteAllTablesContent()
                    // await openDB(true)

                    const user_data = { ...data.single.user_data, delete_active: data.single.delete_active, languages: languages }
                    console.log('DATA USER', user_data)
                    //await addUser(database, user_data)
                    await updateUser(database, user_data._id, { languages })
                } catch (error) {
                    console.error('Error al agregar usuario:', error)
                }
                let version_update = data.single.user_data.data_version ? data.single.user_data.data_version : 0
                // await updateGlobalVersion(database, 'user', version_update)
                console.log('Datos guardados localmente')
                // data.single.user_data.avatar = photoURL
                let dataSave = data.single.user_data
                dataSave.languages = languages
                dataSave.delete_active = data.single.delete_active ?? false
                onSave(dataSave)
                //Tendria que setear al user??
            }
        } catch (error) {
            console.error('1Error al obtener el usuario autenticado:', error)
        }
    }

    const handleResendCode = async (type) => {
        try {
            const user = await getCurrentUser()
            let response
            if (type === 'phone') {
                let phone = formData['Teléfono'].startsWith('+549') ? formData['Teléfono'] : `+549${formData['Teléfono']}`

                console.log('🚀 ~ handleResendCode ~ phone:', phone)
                // response = await updateUserAttributes({ userAttributes: { phone_number: phone } }) // Reenviar código SMS

                response = await sendUserAttributeVerificationCode({
                    userAttributeKey: 'phone_number',
                })

                console.log('🚀 ~ handleResendCode ~ response:', response)
                
                if (response && response.deliveryMedium === 'SMS' && response.attributeName === 'phone_number') {
                    openBottomSheet(
                        <EmailWidget
                            type={'phone'}
                            formData={formData}
                            user_data={user_data}
                            closeBottomSheet={closeBottomSheet}
                            fieldsMap={fieldsMap}
                            fetchData={fetchData}
                        />,
                    )
                    console.log('Código reenviado correctamente por SMS')
                } else {
                    throw new Error('No se pudo reenviar el código SMS')
                }
            } else if (type === 'email') {

                response = await sendUserAttributeVerificationCode({
                    userAttributeKey: 'email',
                })

                console.log('🚀 ~ EMAIL - handleResendCode ~ response:', response)

                if (response && response.deliveryMedium === 'EMAIL' && response.attributeName === 'email') {
                    openBottomSheet(
                        <EmailWidget
                            type={'email'}
                            formData={formData}
                            user_data={user_data}
                            closeBottomSheet={closeBottomSheet}
                            fieldsMap={fieldsMap}
                            fetchData={fetchData}
                        />,
                    )
                    console.log('Código reenviado correctamente por email')
                } else {
                    throw new Error('No se pudo reenviar el código de email')
                }
            }
        } catch (error) {
            console.error('Error reenviando el código:', error.message || error)
            // Aquí podrías mostrar una notificación o manejar el error de otra forma
        }
    }

    const fontScale = 1
    const iconSize = 18 * fontScale

    const changeLanguage = (val) => {
        openBottomSheet(
            <View style={styles.containerModal}>
                {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}
                <Image style={styles.image} source={require('../../../assets/changeLanguage.png')} />
                <Text style={styles.title}>{languageFile.change_language_title}</Text>
                <Text style={styles.description}>{languageFile.change_language_message}</Text>
                <View style={styles.buttonContainer}>
                    <TouchableOpacity
                        onPress={async () => {
                            await updateProfile({ language: val })
                            setShowLanguageAlert(false)
                        }}
                        style={styles.mainButton}
                    >
                        <Text style={styles.mainButtonText}>{languageFile.accept}</Text>
                    </TouchableOpacity>

                    <TouchableOpacity
                        onPress={async () => {
                            setNewLanguage(defaultLanguage)
                            setShowLanguageAlert(false)
                        }}
                        style={styles.borderButton}
                    >
                        <Text style={styles.borderButtonText}>{languageFile.cancel}</Text>
                    </TouchableOpacity>
                </View>
                <View style={styles.spacer3}></View>
            </View>,
        )
    }
    const getFormNameTranslation = (key) => {
        switch (key.toLowerCase()) {
            case 'email':
                return languageFile.email
            case 'teléfono':
                return languageFile.phone
            case 'nombre':
                return languageFile.name
            case 'apellido':
                return languageFile.last_name
            case 'rol':
                return languageFile.role
            case 'area':
                return 'Puesto'
            default:
                return '-'
        }
    }
    const confirmDeleteUser = () => {
        openBottomSheet(
            <View style={{ flex: 1 }}>
                {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}
                <View style={styles.messageContainer}>
                    <View>
                        <Image style={styles.image} source={require('../../../assets/deleteUser.png')} resizeMode='contain' />
                    </View>
                    <Text style={styles.title}>{'¿Estás seguro de que quieres eliminar tu cuenta?'}</Text>

                    <Text style={styles.description}>
                        {
                            'Si confirmas, perderás acceso de forma permanente a la aplicación y no podrás recuperar la información almacenada en ella. Asegúrate de que esta es tu decisión final antes de proceder.'
                        }
                    </Text>
                    <View style={styles.buttonContainer}>
                        <TouchableOpacity style={styles.borderRedButton} onPress={() => handleDeleteUser()}>
                            <Text style={styles.borderRedButtonText}>{languageFile.accept}</Text>
                        </TouchableOpacity>
                        <TouchableOpacity
                            style={[styles.borderRedButton, { backgroundColor: theme.colors.error }]}
                            onPress={() => closeBottomSheet(true)}
                        >
                            <Text style={styles.mainButtonText}>{languageFile.cancel}</Text>
                        </TouchableOpacity>
                    </View>
                </View>
            </View>,
        )
    }

    const isEntornoTest = isEntornoTesting()



    return (
        <View style={styles.container}>
            <ScrollView showsVerticalScrollIndicator={false} style={{ paddingHorizontal: 12 }}>
                <View style={styles.scrollView}>
                    <View>
                        <ProfileHeader
                            avatar={avatarUrl}
                            fullName={user_data?.name ?? ''}
                            user={user_data}
                            version={'v1.0.0'}
                            onClickEdit={goEditProfile}
                            activeButtonDeleted={activeButtonDeleted}
                            onClickDelete={() => closeBottomSheet(true)}
                            onClickChangePassword={() => handleRecoverPassword()}
                        />

                        <View style={styles.containerEditPhoto}>
                            <Image
                                style={styles.avatar}
                                source={safeImageSource(photoURL, Platform.OS === 'web' ? avatarPlaceholder : getAvatarPlaceholderLocal())}
                            />

                            <View style={styles.spacer1}></View>
                        </View>

                        {isConnected && hasInternet && languages.length > 1 && (
                            <View>
                                <Text style={styles.tagInput}>{languageFile.change_language}</Text>
                                <SelectList
                                    placeholder={newLanguage}
                                    data={languages}
                                    defaultOption={newLanguage}
                                    setSelected={(val) => onLanguageChange(val)}
                                    save='value'
                                    search={false}
                                    arrowicon={<Feather name={'chevron-down'} size={iconSize} color={theme.colors.colorPrimary} />}
                                    boxStyles={styles.input}
                                    dropdownStyles={styles.dropdown}
                                    dropdownTextStyles={styles.dropdownOptions}
                                    inputStyles={styles.dropdownInput}
                                />
                            </View>
                        )}
                        {Object.keys(formData).map((key) => (
                            <View key={key} style={{ flex: 1, marginBottom: 16 }}>
                                <Text style={styles.tagInput}>{getFormNameTranslation(key)}</Text>
                                <View style={styles.inputRow}>
                                    <Text style={styles.data}>{formData[key] ? formData[key] : key.charAt(0).toUpperCase() + key.slice(1)}</Text>
                                    {isEnabledEditParams() &&
                                        (key === 'Email' || key === 'Teléfono' || key === 'Apellido' || key === 'Nombre') && (
                                            <TouchableOpacity onPress={() => openModal(key)} style={styles.editIcon}>
                                                <Feather
                                                    name='edit-2'
                                                    size={iconSize}
                                                    color={theme.colors.colorPrimary}
                                                    style={[styles.marginLeft, styles.marginBottom]}
                                                />
                                            </TouchableOpacity>
                                        )}
                                </View>
                                {key === 'Email' &&
                                    isEnabledEditParams() &&
                                    cognitoHasEmail &&
                                    (verifiedEmail ? (
                                        <View style={styles.containerRow}>
                                            <Text style={styles.textVerified}>{languageFile.verified}</Text>
                                            <Feather name='check' size={iconSize} color={theme.colors.colorApproved} style={styles.marginLeft} />
                                        </View>
                                    ) : (
                                        <TouchableOpacity
                                            onPress={() => handleVerificationClick('email')}
                                            disabled={isButtonDisabled}
                                            style={[styles.containerRow, isButtonDisabled && { opacity: 0.5 }]}
                                        >
                                            <Text style={styles.textToVerify}>
                                                {isButtonDisabled ? `Reintentar en ${formatTime(timer)}s` : languageFile.verify}
                                            </Text>
                                            <Feather name='clock' size={iconSize} color={theme.colors.colorPrimary} style={styles.marginLeft} />
                                        </TouchableOpacity>
                                    ))}
                                {key === 'Teléfono' &&
                                    isEnabledEditParams() &&
                                    cognitoHasPhone &&
                                    (verifiedPhone ? (
                                        <View style={styles.containerRow}>
                                            <Text style={styles.textVerified}>Verificado</Text>
                                            <Feather name='check' size={iconSize} color={theme.colors.colorApproved} style={styles.marginLeft} />
                                        </View>
                                    ) : (
                                        <TouchableOpacity
                                            onPress={() => handleVerificationClick('phone')}
                                            disabled={isButtonDisabled}
                                            style={[styles.containerRow, isButtonDisabled && { opacity: 0.5 }]}
                                        >
                                            <Text style={styles.textToVerify}>
                                                {isButtonDisabled ? `Reintentar en ${formatTime(timer)}s ` : languageFile.verify}
                                            </Text>
                                            <Feather name='clock' size={iconSize} color={theme.colors.colorPrimary} style={styles.marginLeft} />
                                        </TouchableOpacity>
                                    ))}
                            </View>
                        ))}

                        <ProfileSection image={''} sectionName={languageFile.contact_channels} show={openContact} />

                        <View style={styles.spacer1}></View>
                        <View style={styles.spacer1}></View>
                    </View>
                </View>
            </ScrollView>

            {/*Botones fijos del divider para abajo*/}
            <View>
                <LinearGradient
                    style={styles.shadow}
                    colors={ProfileDividerTheme.shadowColors}
                    start={{ x: 0, y: 0 }}
                    end={{ x: 0, y: 1 }}
                ></LinearGradient>
                <View style={styles.divider}></View>
                <View style={styles.spacer1}></View>
            </View>
            <View style={[styles.buttonContainer, styles.paddingHorizontal]}>
                {Platform.OS !== 'web' && (
                    <TouchableOpacity onPress={searchUpdates} style={styles.borderButton}>
                        <Text style={styles.borderButtonText}>{languageFile.check_for_update}</Text>
                    </TouchableOpacity>
                )}

                {showClearCacheButton ? (
                    <TouchableOpacity onPress={() => handleDeleteTables()} style={styles.borderRedButton} disabled={loading}>
                        <Text style={styles.borderRedButtonText}>{languageFile.clear_cache}</Text>
                        <View style={styles.iconButton}>
                            <Feather name='trash-2' size={iconSize} color={theme.colors.error} />
                        </View>
                    </TouchableOpacity>
                ) : null}

                <TouchableOpacity onPress={() => logOut()} style={styles.logoutBlock} disabled={loading}>
                    <Text style={styles.logoutText}>{languageFile.log_out}</Text>
                </TouchableOpacity>

                {/* <TouchableOpacity onPress={() => ExportDatabase()} style={styles.borderButton}>
                                    <Text style={styles.borderButtonText}>EXPORTAR  BASE DE DATOS</Text>
                                </TouchableOpacity> */}

                <View style={styles.spacer2}></View>
                <View>
                    <Text style={styles.version}>{(isEntornoTest ? 'Dev' : 'Prod') + ' v' + getAppVersion()}</Text>

                    {activeButtonDeleted && (
                        <TouchableOpacity onPress={() => handleDeleteUser()} style={styles.deleteBlock}>
                            <Text style={styles.deleteText}>{languageFile.delete_account}</Text>
                        </TouchableOpacity>
                    )}
                    <View style={styles.spacer1}></View>
                    {Platform.OS == 'ios' && <View style={{ height: 20 }} />}
                </View>
            </View>

            <Modal
                visible={showRecoverPassword}
                animationType='slide'
                onRequestClose={() => setShowRecoverPassword(false)}
                style={{ alignContent: 'center' }}
            >
                <View style={{ flex: 1, justifyContent: 'center' }}>
                    <RecoverPasswordView showLogin={() => setShowRecoverPassword(false)} username={currentUsername} skipUsernameInput={true} />
                </View>
            </Modal>
        </View>
    )
}
